import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowmoreFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.187 8.687a1.15 1.15 0 0 1 1.626 0L12 13.874l5.187-5.187a1.15 1.15 0 0 1 1.626 1.626l-6 6a1.15 1.15 0 0 1-1.626 0l-6-6a1.15 1.15 0 0 1 0-1.626",
    clipRule: "evenodd"
  }));
}
var IcArrowmoreFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowmoreFill));

export { IcArrowmoreFill as I };
